<div class="document-processing-container">
  <div class="header">
    <h1>Herramientas</h1>
    <p>Selecciona la herramienta que deseas utilizar</p>
  </div>

  <div class="buttons-container">
    <div class="processing-card" (click)="navigateToExcelConverter()">
      <div class="card-icon">
        <i class="material-icons">table_chart</i>
      </div>
      <div class="card-content">
        <h3>Holded → Sage200</h3>
        <p>Convierte archivos Excel de Holded al formato requerido por Sage200. Versión actual con filtrado por ID de documento</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>

    <div class="processing-card" (click)="navigateToCdrBilling()">
      <div class="card-icon">
        <i class="material-icons">receipt_long</i>
      </div>
      <div class="card-content">
        <h3>Facturación CDR</h3>
        <p>Obtiene y procesa los CDR del Document Store automáticamente para generar el fichero de facturación</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>

    <div class="processing-card" (click)="navigateToEsimCatalog()">
      <div class="card-icon">
        <i class="material-icons">sim_card_download</i>
      </div>
      <div class="card-content">
        <h3>Catálogo eSIM</h3>
        <p>Descarga el listado completo de paquetes eSIM con precios de coste y venta en formato .xlsx</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>
  </div>

  <div class="section-divider">
    <span>Pruebas / obsoletas</span>
  </div>

  <div class="buttons-container">
    <div class="processing-card" (click)="navigateToExcelConverter2025()">
      <div class="card-icon">
        <i class="material-icons">table_chart</i>
      </div>
      <div class="card-content">
        <h3>Holded → Sage200 (2025)</h3>
        <p>Convierte archivos Excel de Holded al formato requerido por Sage200. Versión de 2025 con filtrado por tags y usuarios.</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>

    <div class="processing-card" (click)="navigateToCdrProcessing()">
      <div class="card-icon">
        <i class="material-icons">phone_callback</i>
      </div>
      <div class="card-content">
        <h3>Procesamiento de CDR</h3>
        <p>Procesa archivos CDR (Call Detail Records) para análisis de llamadas</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>

    <div class="processing-card" (click)="navigateToDocumentStore()">
      <div class="card-icon">
        <i class="material-icons">description</i>
      </div>
      <div class="card-content">
        <h3>Document Store (CPaaS)</h3>
        <p>Consulta, filtra y descarga documentos del Document Store de Telekom CPaaS</p>
      </div>
      <div class="card-arrow">
        <i class="material-icons">arrow_forward</i>
      </div>
    </div>
  </div>
</div>
